import { combineReducers } from 'redux';
import passportReducers from '@kuaizhan/kz-frame/passport/reducers';
import headerReducer from '@kuaizhan/kz-frame/modules/header/reducers';

export default combineReducers({
    ...passportReducers,
    header: headerReducer,
});
